import { createAsyncThunk } from '@reduxjs/toolkit';
import i18n from 'i18n';
import { requestInvoice } from 'store/api/cuverse-api/invoice/invoice.service';
import {
  InvoicesResponseSchema,
  TInvoicesData,
} from 'store/api/cuverse-api/invoice/types/invoice-response.interface';

import { requestWithZodSchema } from 'utils/common/requestWithZodSchema';
import { notifyError, notifySuccess } from 'utils/notify/notify.utils';

export const fetchInvoiceThunkAction = createAsyncThunk(
  'invoiceCheckout/fetch',
  async (purchaseId: number): Promise<TInvoicesData> => {
    return await requestWithZodSchema(
      () => requestInvoice({ purchase_id: purchaseId, operation_type: 'pool_miner' }),
      InvoicesResponseSchema,
    )
      .then((res) => {
        notifySuccess(i18n.t('notifyMessages.invoice.createSuccess'));

        return res;
      })
      .catch((error) => {
        notifyError(i18n.t('notifyMessages.invoice.createError'));

        throw error;
      });
  },
);
